var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { batchShipmentSuccess, batchShipmentFailure, BATCH_SHIPMENT_REQUEST } from "@/redux/actions";
import APIIN from "@/utils/APIIN";
const batchShipmentDetails = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.post("/pmnt/wallet/buy/batch", action.payload)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* batchShipmentDetailsWorker(action) {
    try {
        const data = yield call(batchShipmentDetails, action);
        yield put(batchShipmentSuccess(data));
    }
    catch (error) {
        yield put(batchShipmentFailure(error));
    }
}
export function* watchBatchShipmentDetailsData() {
    yield takeLatest(BATCH_SHIPMENT_REQUEST, batchShipmentDetailsWorker);
}
